import { render } from "./DemoCrudIntView.vue?vue&type=template&id=0f169586&scoped=true"
import script from "./DemoCrudIntView.vue?vue&type=script&lang=js"
export * from "./DemoCrudIntView.vue?vue&type=script&lang=js"

import "./DemoCrudIntView.vue?vue&type=style&index=0&id=0f169586&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f169586"]])

export default __exports__